import React from "react";
import { Link } from "react-router-dom";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import ShareIcon from "@mui/icons-material/Share";
import { SOCIAL_LINKS } from "../../utils/socialLinks";
import "../Footer/Footer.css";

const Footer = () => {
  const handleShare = async () => {
    const shareData = {
      title: "LIMPOOK MLBB",
      text: "Stay updated with LIMPOOK MLBB",
      url: window.location.origin,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(shareData.url);
        alert("Link copied!");
      }
    } catch {
      // ignore cancel
    }
  };

  return (
    <footer className="gameFooter">
      <div className="gameFooter-inner">
        <div className="gameFooter-main">
          <div className="gameFooter-brand">
            <Link to="/" className="gameFooter-logo" aria-label="LIMPOOK home">
              LIMP<span>OOK</span>
            </Link>
            <p>
              LIMPOOK Official Store is your quick stop for game top-ups, account checks,
              wallet reloads, and support.
            </p>

            <div className="gameFooter-brandSocials" aria-label="Social links">
              <a
                href={SOCIAL_LINKS.whatsappGroup}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp group"
              >
                <WhatsAppIcon />
              </a>

              <a
                href={SOCIAL_LINKS.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>

              <a
                href={SOCIAL_LINKS.youtube}
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
              >
                <YouTubeIcon />
              </a>

              <button type="button" onClick={handleShare} aria-label="Share website">
                <ShareIcon />
              </button>
            </div>
          </div>

          <div className="gameFooter-col">
            <h3>Product & Service</h3>
            <Link to="/games">Games</Link>
            <Link to="/name-check">Check Region</Link>
            <Link to="/leaderboard">Leaderboard</Link>
            <Link to="/add-balance">Add Coin</Link>
          </div>

          <div className="gameFooter-col">
            <h3>Support & Information</h3>
            <a href="mailto:support@limpookmlbb.com">
              support@limpookmlbb.com
            </a>
            <a href={SOCIAL_LINKS.whatsappSupport} target="_blank" rel="noreferrer">
              WhatsApp: +91 8072 865 201
            </a>
            <a
              href={SOCIAL_LINKS.instagram}
              target="_blank"
              rel="noreferrer"
            >
              Instagram Updates
            </a>
            <Link to="/orders">Order History</Link>
            <Link to="/refund-policy">Refund Policy</Link>
          </div>

          <div className="gameFooter-col">
            <h3>Legal</h3>
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <button type="button" onClick={handleShare}>
              Share Website
            </button>
          </div>
        </div>

        <div className="gameFooter-bottom">
          <div className="gameFooter-copy">
            Copyright {new Date().getFullYear()} LIMPOOK MLBB. All rights reserved.
          </div>

          <div className="gameFooter-legal">
            <Link to="/terms">Website Terms</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/refund-policy">Refund Policy</Link>
          </div>

          <div className="gameFooter-region">India</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
